<template>
  <div class="color-palettes w-100">
    <div
      v-if="hasImport"
      class="color-palettes_btns"
    >
      <div
        class="gw_btn flex-1 csst tooltip-all-devices"
        @click.stop="copyToClipboard(false)"
      >
        <i class="mdi mdi-tray-arrow-up mr-1"></i>
        {{ $t('btn.export') }}
        <div
          class="csst_content trapresitm_btn_tooltip"
          :style="
            copied
              ? `
                  white-space: normal;
                  word-break: break-word;
                  background:var(--clr-primary);
                  width:12rem;
                  transform:translate(0,105%);
                  left:0;
                  `
              : 'transform:translate(0,140%); white-space:nowrap; left:0;'
          "
          :class="{ csst_content_visible: copied }"
          v-html="
            copied ? $t('tooltips.color_theme_in_clipboard') : $t('tooltips.copy_color_theme')
          "
        ></div>
      </div>
      <div
        class="gw_btn flex-1"
        @click="$store.dispatch('router_set_dialogs', 'import-color-palette-dialog')"
      >
        <i class="mdi mdi-tray-arrow-down mr-1"></i> {{ $t('btn.import') }}
      </div>
    </div>

    <div
      ref="custom"
      class="color-palette-container custom-pallete"
      :class="{ 'color-palette-container_selected': usingCustomPallete }"
      @click="usePalette(customPallete)"
    >
      <div
        class="color-palette_name"
        @click="$emit('click:pencil')"
      >
        {{ $t('color_palettes.custom') }}
        <div
          v-if="hasEdit"
          class="gw_btn gw_btn_text plts_edit clr-grey ml-auto text-nowrap weight_500 text-small"
          style="--padding: 0.25rem"
        >
          <div class="mdi mdi-pencil pa-1 csst z-index_2 text-small">
            {{ $t('btn.edit') }}
          </div>
        </div>
      </div>
      <div
        class="color-palette-gradient"
        :style="`--clr-gradient:linear-gradient(90deg,${getGradient(customPallete)})`"
      />
    </div>
    <div
      v-for="(p, idx) in colorPalettes"
      :key="idx + 'p'"
      :ref="p.id"
      class="color-palette-container"
      :class="[{ 'color-palette-container_selected': selectedPalleteID === p.id }]"
      @click="usePalette(p)"
    >
      <div
        class="color-palette_name icon_btn_cont_hover"
        @click="$emit('click:pencil')"
      >
        {{ $t(`themes.${p.id}`) }}
        <span
          v-if="p.owner"
          class="text-smallest clr-grey pl-2"
          >({{ p.owner }})</span
        >

        <div
          v-if="hasEdit"
          class="gw_btn gw_btn_text plts_edit clr-grey ml-auto text-nowrap weight_500 text-small"
          style="--padding: 0.25rem"
        >
          <div class="mdi mdi-pencil pa-1 csst z-index_2 text-small">
            {{ $t('btn.edit') }}
          </div>
        </div>
      </div>

      <div
        class="color-palette-gradient"
        :style="`--clr-gradient:linear-gradient(90deg,${getGradient(p)})`"
      />
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import {
  getColorPalleteKeys,
  colorPalettes,
  getColorTheme,
  getStyleTheme,
} from '@/store/userSettings/colorPalettes'
import { apiStylesDict } from '@/store/userSettings/apiDicts'

export default {
  name: 'ColorPalettes',
  props: {
    hasImport: { type: Boolean, default: true },
    onlyTrainer: Boolean,
    hasEdit: Boolean,
    customPalleteKey: { default: 'customPallete' },
  },
  emits: ['click:pencil'],
  data() {
    return {
      clrArr: '',
      copied: false,
    }
  },
  created() {
    this.persistLocalPallete(this.customPallete)
  },
  methods: {
    getGradient(palette) {
      const l = palette.colors.filter(i => i).length
      const res = palette.colors
        .filter(i => i)
        .map((i, idx) => {
          const _1st = `${i} ${(100 / l) * idx}%`
          const _2nd = `${i} ${(100 / l) * (idx + 1)}%`
          const r = [_1st, _2nd].join(', ')
          return r
        })
        .join(', ')
      // console.log(res)
      return res
    },
    copyToClipboard(bool) {
      this.copied = true
      let str = ''
      const clrs = this.selectedColors.join(',')
      const styles = this.userStyles.join(',')
      // `
      str = `${clrs};${styles}`
      // `
      // str = clrs

      navigator.clipboard.writeText(str)
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    usePalette(p) {
      let { colors, styles, id } = p
      // console.log(id, this.selectedPalleteID)
      if (id === this.selectedPalleteID) return

      const currentColors = this.getSelectedColors()
      colors = colors.map((cc, idx) => cc || currentColors[idx])
      const settingsColors = getColorTheme(colors)

      // const currentStyles = this.getSelectedStyles()
      const settingsStyles = styles ? getStyleTheme(styles) : {}
      const settings = {
        ...settingsColors,
        ...settingsStyles,
      }
      this.$store.dispatch('userSettings', settings)
      this.$store.dispatch('resetColorSettings')

      // debugger
      // if (this.usingCustomPallete) {
      //   this.persistLocalPallete({ colors, styles })
      // }
      setTimeout(() => {
        this.$store.dispatch('gamestate_repaint_actions', 'ColorPalettes')
        this.$store.getters.hands_namespaces.forEach(nn => {
          this.$store.dispatch(`${nn}/gamestate_repaint_actions`, 'ColorPalettes')
        })
      }, 200)
    },
    persistLocalPallete({ colors, styles }) {
      if (this.usingCustomPallete && !this.onlyTrainer) {
        const res = `${colors.join(',')};${styles ? styles.join(',') : ''}`
        // debugger
        // console.log('save localPallete', this.customPalleteKey, { colors, styles })
        localStorage.setItem(this.customPalleteKey, res)
        if (this.customPalleteKey === 'customPalleteTrainer') {
          // debugger
          console.log('set custom trainer palette')
        }
      }
    },
    getSelectedColors(onlyTrainer = false) {
      const { mergedUserSettings } = this.$store.getters
      const clrKeys = getColorPalleteKeys()
      const other = onlyTrainer
        ? {}
        : {
            ...mergedUserSettings.actionsColors,
            ...mergedUserSettings.typographyColors,
            ...mergedUserSettings.otherColors,
            ...mergedUserSettings.suitsColors,
            ...mergedUserSettings.ipOopColors,
          }
      const allColorsByName = {
        ...other,
        ...mergedUserSettings.trainerTableColors,
      }
      const selectedColors = []
      clrKeys.forEach(key => {
        selectedColors.push(allColorsByName[key] || '')
      })
      // selectedColors = selectedColors.filter(c => c)
      // console.log(selectedColors)
      return selectedColors
    },
  },
  computed: {
    userStyles() {
      const { mergedUserSettings } = this.$store.getters
      const res = []
      const ss = apiStylesDict()
      Object.keys(ss).forEach(key => {
        const valKey = ss[key].feKey
        // res.push([ss[valKey], mergedUserSettings[valKey]])
        res.push(mergedUserSettings[valKey])
      })
      // res = res.join(',')
      return res
    },
    actions() {
      const clrKeys = getColorPalleteKeys()
      const res = getColorPalleteKeys().map(i => {
        const r = {
          id: i,
          idx: clrKeys.findIndex(c => i === c),
        }
        return r
      })
      return res
    },
    selectedColors() {
      return this.getSelectedColors(this.onlyTrainer)
    },
    selectedPalleteID() {
      const res = this.colorPalettes.find(p => {
        const r = isEqual(p.colors, this.selectedColors)
        return r
      })
      // if (!this.onlyTrainer) {
      //   console.log(res)
      // }
      // console.log(res?.id)
      return res?.id
    },
    usingCustomPallete() {
      // console.log(this.selectedPalleteID)
      return !this.selectedPalleteID
    },
    colorPalettes() {
      let opts = colorPalettes()
      if (this.onlyTrainer) {
        opts = opts.filter(p => p.onlyTrainer)
      } else {
        opts = opts.filter(p => !p.onlyTrainer)
      }

      const res = opts.map(c => ({
        id: c.id,
        colors: c.colors.map((i, idx) => (this.selectedColors[idx] ? i : '')),
        styles: c.styles,
        onlyTrainer: c.onlyTrainer,
        owner: c.owner,
      }))

      // console.log(res)

      return res
    },
    customPallete() {
      if (this.usingCustomPallete) {
        return {
          colors: this.selectedColors,
          styles: this.userStyles,
        }
      }
      const keysLength = getColorPalleteKeys().length
      const fallBackPallete = [...Array(keysLength).keys()].map(i =>
        i.length === 7 ? '#777777' : '#7777778F',
      )
      const ccpp = localStorage.getItem(this.customPalleteKey)

      let colors = []
      let styles = []

      try {
        const stylesStartIndex = ccpp.indexOf(';')
        colors = ccpp.substring(0, stylesStartIndex)
        styles = ccpp.substring(stylesStartIndex + 1)
        colors = colors.split(',')
        styles = styles.split(',')
        // debugger
      } catch (error) {
        colors = fallBackPallete
      }

      colors = colors.map((i, idx) => (this.selectedColors[idx] ? i : ''))
      // debugger
      const res = {
        colors,
        styles,
      }
      // console.log(res)
      return res
    },
  },
  watch: {
    customPallete(ccpp) {
      this.persistLocalPallete(ccpp)
    },
    selectedPalleteID(id) {
      const ref = this.$refs[id || 'custom']
      // console.log(ref, this.onlyTrainer)
      if (ref) {
        ;(ref[0] || ref).scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 812px) {
  .color-palettes {
    flex-direction: column;
  }
  .color-palette_block {
    margin-top: 1rem;
    padding: 0 !important;
    border: none !important;
  }
}
.color-palette {
  &_block {
    border-left: solid var(--clr-black-3) 1px;
    padding: 0 1rem;
  }
  &_name {
    color: var(--clr-white-0);
    display: flex;
    align-items: flex-end;
    padding: 0 0 0.125rem 0;
    // font-size: 0.875rem;
  }
  // &_selected {
  //   --clr-shadow: var(--clr-primary);
  // }
}
.color-palettes {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  --overflow-y: unset;
  --grid-gap: 1rem;
  overflow-y: var(--overflow-y);
  overflow-x: unset;

  // --grid-columns: 1fr;
  // grid-template-columns: var(--grid-columns);
  grid-gap: var(--grid-gap);
  --clr-btns-back: var(--clr-black-1);
  --palette-width: 100%;
  width: 100%;
  &_btns {
    display: flex;
    position: sticky;
    flex-wrap: wrap;
    grid-gap: 0.25rem;
    width: 100%;
    max-width: 14rem;

    top: -1rem;
    z-index: 2;
    padding: 0.5rem 0;
    margin-bottom: -0.5rem;
    margin-top: -0.5rem;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      background: var(--clr-btns-back);
      height: 100%;
      width: 120%;
      left: -10%;
      z-index: -1;
    }
    .gw_btn {
      z-index: 2;
    }
  }
  .color-palette-container {
    align-self: flex-start;
    cursor: pointer;
    transition: 0.2s;
    width: var(--palette-width);
    --clr-shadow: var(--clr-black-3);
    --shadow-width: 2px;
    &_selected {
      --clr-shadow: var(--clr-primary);
      --shadow-width: 2px;
    }
    .color-palette-gradient {
      display: grid;
      height: 2rem;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 0px 0px var(--shadow-width) var(--clr-shadow);
      --dot-size: calc(100% - 4px);
      --clr-gradient: linear-gradient(90deg, red, blue);
      &::before {
        content: '';
        width: var(--dot-size);
        height: var(--dot-size);
        background-image: var(--clr-gradient);
        position: absolute;
        z-index: 1;
        border-radius: 4px;
      }
      border-radius: 4px;
      &:hover {
        --clr-shadow: var(--clr-primary);
        --shadow-width: 2px;
      }
    }
  }
  .color-line {
    flex-grow: 1;
    transition: 0.3s;
  }
}
</style>
